import Link from "next/link";
import React from "react";

function Footer() {
  return (
    <div className="footer-wrap flex items-center justify-center flex-col">
      {/*     <div>
        <img className="footer-logo" src="/src/EW_logo.png" alt="" />
      </div> */}
      {/*    <span className="footer-info-text">
        Parturient parturient hac feugiat vestibulum mauris a proin ridiculus
        blandit torquent etiam lorem integer suspendisse leo condimentum mi
        parturient diam
      </span> */}
      <div className="pb-6 pt-6 footer-linkswrap hide-desktop">
        <a href="/impressum" className="footer-links ">
          Impressum
        </a>
        <a href="/datenschutz" className="footer-links ml-10">
          Datenschutzerklärung
        </a>
        <a href="/nutzungsbedingungen" className="footer-links ml-10">
          Nutzungsbedingungen
        </a>
        <a href="/teilnahmebedingungen" className="footer-links ml-10">
          Teilnahmebedingungen
        </a>
        <a href="https://www.erfolgreichgastro.de/#contactForm" className="footer-links ml-10">
          Kontakt
        </a>
        <a href="/faq" className="footer-links ml-10">
          FAQ
        </a>
      </div>
      <div className="pb-6 footer-linkswrap-mobile hide-mobile">
        <div className="footer-center">
          <a href="/impressum" className="footer-links ml-10">
            Impressum
          </a>
          <a href="/datenschutz" className="footer-links ml-10">
            Datenschutzerklärung
          </a>
        </div>
        <div className="footer-center">
          <a href="/nutzungsbedingungen" className="footer-links">
            Nutzungsbedingungen
          </a>
          <a href="/teilnahmebedingungen" className="footer-links ml-10">
            Teilnahmebedingungen
          </a>
          <a href="https://www.erfolgreichgastro.de/#contactForm" className="footer-links ml-10">
            Kontakt
          </a>
          <a href="/faq" className="footer-links ml-10">
            FAQ
          </a>
        </div>
      </div>
      <div className="footer-logo-images flex justify-center pb-8">
        <Link href="/paulaner" >
          <img src="/src/logos/logo_paulaner.png" alt="Image"></img>
        </Link>
        <Link href="/hacker-pschorr" >
          <img src="/src/logos/logo_hp.png" alt="Image"></img>
        </Link>
        <Link href="/auerbraeu" >
          <img src="/src/logos/logo_auerbraeu.png" alt="Image"></img>
        </Link>
        <Link href="/chiemseer" >
          <img src="/src/logos/logo_chiemseer.png" alt="Image"></img>
        </Link>
        <Link href="/hoepfner" >
          <img src="/src/logos/logo_hoepfner_new.png" alt="Image"></img>
        </Link>
        <Link href="/schmucker" >
          <img src="/src/logos/logo_schmucker_new.png" alt="Image"></img>
        </Link>
        <Link href="/fuerstenberg" >
          <img src="/src/logos/logo_fürstenberg_new.png" alt="Image"></img>
        </Link>
      </div>
    </div>
  );
}

export default Footer;
